var $2566283bdb5134d0$exports = {};
$2566283bdb5134d0$exports = {
    "actions": `Akce`,
    "actionsAvailable": `Dostupn\xe9 akce.`,
    "clearSelection": `Vymazat v\xfdb\u{11B}r`,
    "selected": (args)=>`Vybr\xe1no: ${args.count}`,
    "selectedAll": `Vybr\xe1no v\u{161}e`
};


export {$2566283bdb5134d0$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
